import {
  APP_INITIALIZER,
  ApplicationConfig,
  Provider,
  provideZoneChangeDetection,
} from '@angular/core';
import { provideRouter } from '@angular/router';
import { provideDesignAngularKit } from 'design-angular-kit';

import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { KeycloakAngularModule, KeycloakEvent, KeycloakEventType, KeycloakService } from 'keycloak-angular';
import { routes } from './app.routes';
import { loaderInterceptor } from './interceptors/loader.interceptor';
import { keycloakConfig } from './keycloak.config';
import { authInterceptor } from './interceptors/auth.interceptor';
import { errorInterceptor } from './interceptors/error.interceptor';
import { ContextService } from './services/context.service';

export const KEYCLOAK_INIT_PROVIDER: Provider = {
  provide: APP_INITIALIZER,
  useFactory: initializeKeycloak,
  deps: [KeycloakService, ContextService],
  multi: true,
};

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes),
    provideDesignAngularKit(),
    provideHttpClient(withInterceptors([loaderInterceptor, authInterceptor, errorInterceptor])),
    KeycloakService,
    KEYCLOAK_INIT_PROVIDER,
    KeycloakAngularModule,
  ],
};

function pushAttrsToContext(svc: KeycloakService, ctx: ContextService) {
  svc.loadUserProfile()
    .then((p) => ctx.updateAllowFromAttributes((p as any)?.attributes ?? {}))
    .catch(() => ctx.updateAllowFromAttributes({})); // nessun attributo → liste vuote
}

export function initializeKeycloak(keycloak: KeycloakService, context: ContextService) {
  return async () => {
    await keycloak.init({
      config: keycloakConfig.config,
      initOptions: keycloakConfig.initOptions,
      enableBearerInterceptor: true,
      loadUserProfileAtStartUp: false,
    });

    pushAttrsToContext(keycloak, context);

    keycloak.keycloakEvents$.subscribe((e: KeycloakEvent) => {
      switch (e.type) {
        case KeycloakEventType.OnAuthSuccess:
        case KeycloakEventType.OnAuthRefreshSuccess:
          pushAttrsToContext(keycloak, context);
          break;
        case KeycloakEventType.OnTokenExpired:
          keycloak.updateToken(30)
            .then(() => pushAttrsToContext(keycloak, context))
            .catch(() => context.updateAllowFromAttributes({}));
          break;
        case KeycloakEventType.OnAuthLogout:
          context.clear(); 
          break;
      }
    });

    return true;
  };
}